import { createImpressionEvent } from '../base';
import { HIGHLY_RESPONSIVE_PARAMS } from '../constants';

/**
 * BI impression event for the Highly Responsive component.
 * @param {string} type The event's type.
 * @returns {object} parameters for the event.
 */
export const createHighlyResponsiveImpressionEvent = (type) => createImpressionEvent(type, HIGHLY_RESPONSIVE_PARAMS);
